import { render, staticRenderFns } from "./PartnerReference.vue?vue&type=template&id=72f09530"
import script from "./PartnerReference.vue?vue&type=script&lang=ts"
export * from "./PartnerReference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports